import { render, staticRenderFns } from "./ParallelGateway.vue?vue&type=template&id=8e7e20ec&scoped=true&"
import script from "./ParallelGateway.vue?vue&type=script&lang=js&"
export * from "./ParallelGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7e20ec",
  null
  
)

export default component.exports